<template>
  <div v-if="intercomAvailable" class="messenger-menu-group">
    <button type="button" class="messenger-item" aria-label="Help">
      <SvgIcon name="general/help" width="20" height="20" />
    </button>
    <InfoMarker v-if="showBadge" :top="4" :right="4" />
  </div>
</template>

<script>
import { mapState } from "pinia";

import SvgIcon from "@/components-ng/SvgIcon.vue";
import { useAppStore } from "@/stores";

import InfoMarker from "./InfoMarker.vue";

export default {
  name: "MessengerButton",
  components: { SvgIcon, InfoMarker },
  data() {
    return {
      passiveNotifications: false,
      unreadMessages: false,
    };
  },
  computed: {
    ...mapState(useAppStore, ["intercomAvailable"]),
    showBadge() {
      return this.passiveNotifications || this.unreadMessages;
    },
  },
  mounted() {
    this.checkForPassiveNotifications();
    this.setupListeners();
  },
  methods: {
    checkForPassiveNotifications() {
      const queryString = "[class^='intercom'] [data-testid='passive-notifications']";
      const passiveNotifications = document.querySelector(queryString);
      this.passiveNotifications = !!passiveNotifications;
    },
    setupListeners() {
      if (!("Intercom" in window)) return;

      window.Intercom("onShow", () => {
        this.passiveNotifications = false;
      });
      window.Intercom("onHide", () => {
        setTimeout(() => this.checkForPassiveNotifications(), 100);
      });
      window.Intercom("onUnreadCountChange", (count) => {
        this.unreadMessages = !!count;
      });
    },
  },
};
</script>

<style lang="scss">
@use "@/colors" as c;

.messenger-menu-group {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 999;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 2px;
  width: 40px;
  height: 40px;
  background-color: c.$background-ui;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgb(0 0 0 / 10%);
}

.messenger-item {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 8px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: c.$grey-dark;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    background-color: c.$background-alpha-hover;
    color: c.$text;
  }

  &:active {
    background-color: c.$background-alpha-active;
    color: c.$text;
  }

  &:focus-visible {
    outline: 2px solid c.$main;
    outline-offset: 2px;
  }
}

.intercom-launcher,
.intercom-launcher-frame,
.intercom-dfosxs,
 // Hide intercom's trigger (unfortunately, the trigger's class changes with every intercom deployment,
 // but it seems to consistently start with "intercom-with-namespace-xxxxxx")
.intercom-app > [class^="intercom-with-namespace-"]:not(.intercom-messenger-frame) {
  display: none !important;
  pointer-events: none !important;
}
</style>
